import { Box } from '@material-ui/core';

import { StyledSkeleton } from '@/components/modules/AssetDetails/components/shared/StyledSkeleton';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';

export const AutoDetailsDataSkeleton = () => {
  return (
    <>
      <Box pt={3}>
        <FormGridContainer>
          {[...Array(2)].map(() => (
            <StyledSkeleton />
          ))}
        </FormGridContainer>
      </Box>
      <Box pt={3}>
        <FormGridContainer>
          {[...Array(6)].map(() => (
            <StyledSkeleton />
          ))}
        </FormGridContainer>
      </Box>
      <Box pt={3}>
        <FormGridContainer>
          {[...Array(9)].map(() => (
            <StyledSkeleton />
          ))}
        </FormGridContainer>
      </Box>
    </>
  );
};
